require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-announcing-buildthings.json") })
        }
      }, "path---blog-announcing-buildthings");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-announcing-buildthings!./.cache/json/blog-announcing-buildthings.json
// module id = 808
// module chunks = 231608221292675